import { render, staticRenderFns } from "./GerenciaCadastroQhAtvExtras.vue?vue&type=template&id=59390d8a&scoped=true"
import script from "./GerenciaCadastroQhAtvExtras.vue?vue&type=script&lang=js"
export * from "./GerenciaCadastroQhAtvExtras.vue?vue&type=script&lang=js"
import style0 from "./GerenciaCadastroQhAtvExtras.vue?vue&type=style&index=0&id=59390d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59390d8a",
  null
  
)

export default component.exports